import { useEffect, useState } from "react";
import {
  MobileDropBoxItem,
  MobileDropBoxOptionWrapper,
  MobileDropBoxValue,
  MobileSolutionHistoryBoarder,
  MobileSolutionHistoryWrapper,
  MobileSolutionHistoryHeaderValue,
  MobileSolutionHistoryHeaderWrapper,
  MobileDropBoxWrapper,
  MobileSolutionHistorySearchWrapper,
  MobileSolutionHistorySearch,
} from "./style";
import WalletLogsList from "./components/log-list";
import MobileHeader from "../../../../../../layout/mobile-header";
import {
  getSettlementPubPointLogs,
  getSettlementRabbitLogs,
  getSettlementLegacySeedLogs,
  getSettlementCarrotLogs,
  SettlementLogResponse,
  SettlementResponse,
} from "../../../../../../api/settlement";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../../../recoil/pub.atom";

interface MobileSolutionHistoryProps {
  onClose: () => void;
  type: string;
  data: SettlementResponse | undefined;
  date: string;
}

export interface DateSettlementLogDto {
  date: string;
  list: SettlementLogResponse[];
}

const MobileSolutionHistory = ({
  onClose,
  type,
  data,
  date,
}: MobileSolutionHistoryProps) => {
  const pub = useRecoilValue(pubState);
  const [list, setList] = useState<DateSettlementLogDto[]>([]);
  const [allList, setAllList] = useState<SettlementLogResponse[]>([]);
  const [dateFilter, setDateFilter] = useState<string>("DAY");
  const [isDateOpen, setIsDateOpen] = useState<boolean>(false);
  const [searchMember, setSearchMember] = useState<string>("");

  const getLogs = async () => {
    if (!pub) return;
    switch (type) {
      case "POINT":
        const pointList = await getSettlementPubPointLogs(
          pub.id,
          date,
          dateFilter
        );
        setAllList(pointList);
        break;
      case "SEED":
        const rabbitList = await getSettlementRabbitLogs(
          pub.id,
          date,
          dateFilter
        );
        setAllList(rabbitList ?? []);
        break;
      case "LEGACY_SEED":
        const legacySeedList = await getSettlementLegacySeedLogs(
          pub.id,
          date,
          dateFilter
        );
        setAllList(legacySeedList ?? []);
        break;
      case "CARROT":
        const carrotList = await getSettlementCarrotLogs(
          pub.id,
          date,
          dateFilter
        );
        setAllList(carrotList ?? []);
        break;
    }
  };

  const onSearchClick = () => {
    const filteredList = allList.filter((item) =>
      item.nickname.toLowerCase().includes(searchMember.toLowerCase())
    );

    // 포인트 로그 그룹 초기화
    const groupedLogs: { [key: string]: SettlementLogResponse[] } = {};

    // 포인트 로그 그룹화
    for (const log of filteredList) {
      const dateKey = new Date(log.date).toISOString().split("T")[0];

      if (!groupedLogs[dateKey]) {
        groupedLogs[dateKey] = [];
      }
      groupedLogs[dateKey].push(log);
    }

    // 포인트 로그 정렬 및 응답 생성
    const resultList: DateSettlementLogDto[] = Object.keys(groupedLogs)
      .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
      .map((date) => ({
        date,
        list: groupedLogs[date],
      }));

    setList(resultList);
  };

  useEffect(() => {
    onSearchClick();
  }, [searchMember, allList]);

  // 최초 실행 api
  useEffect(() => {
    getLogs();
  }, [pub, dateFilter]);

  const getHeaderText = () => {
    switch (type) {
      case "POINT":
        return "매장이용권";
      case "SEED":
        return "크레딧";
      case "LEGACY_SEED":
        return "(구)크레딧";
      case "CARROT":
        return "캐럿";
      default:
        return "";
    }
  };

  const getPointUnit = () => {
    switch (type) {
      case "POINT":
        return "E";
      case "SEED":
      case "LEGACY_SEED":
        return "RABBIT";
      case "CARROT":
        return "CARROT";
    }
  };

  const getPoint = () => {
    switch (type) {
      case "POINT":
        return (data?.pubPoint || 0) / 10000;
      case "SEED":
      case "LEGACY_SEED":
        return +(data?.pubSeed || 0);
      case "CARROT":
        return +(data?.pubCarrot || 0);
      default:
        return 0;
    }
  };

  const dateFilterList = [
    {
      name: "오늘",
      value: "DAY",
    },
    {
      name: "이번주",
      value: "WEEK",
    },
    {
      name: "이번달",
      value: "MONTH",
    },
  ];

  return (
    <MobileSolutionHistoryWrapper>
      <MobileHeader title={getHeaderText()} back={onClose} />
      <MobileSolutionHistoryHeaderWrapper>
        <MobileSolutionHistoryHeaderValue>
          <div className="title">{getHeaderText()}</div>
          <div className="point">
            {getPoint()?.toLocaleString()}
            <span>{getPointUnit()}</span>
          </div>
        </MobileSolutionHistoryHeaderValue>
        <MobileDropBoxWrapper onClick={() => setIsDateOpen(!isDateOpen)}>
          <MobileDropBoxValue>
            <div className="value">
              {dateFilterList.find((item) => item.value === dateFilter)?.name}
            </div>
            <img src="/image-web/icon/down_arrow.svg" alt="arrow" />
          </MobileDropBoxValue>
          {isDateOpen && (
            <MobileDropBoxOptionWrapper>
              {dateFilterList.map((item, i) => (
                <MobileDropBoxItem
                  isSelected={item.value === dateFilter}
                  key={i}
                  onClick={() => setDateFilter(item.value)}
                >
                  <span>{item.name}</span>
                </MobileDropBoxItem>
              ))}
            </MobileDropBoxOptionWrapper>
          )}
        </MobileDropBoxWrapper>
      </MobileSolutionHistoryHeaderWrapper>
      <MobileSolutionHistoryBoarder />
      <MobileSolutionHistorySearchWrapper>
        <div className="title">내역</div>
        <MobileSolutionHistorySearch>
          <input
            value={searchMember}
            onChange={(e) => setSearchMember(e.target.value)}
            placeholder="닉네임을 검색하세요."
          />
          <img
            src="/image-web/timer-config/searchIcon.svg"
            alt="search"
            onClick={onSearchClick}
          />
        </MobileSolutionHistorySearch>
      </MobileSolutionHistorySearchWrapper>
      <WalletLogsList
        list={list}
        type={type === "LEGACY_SEED" ? "SEED" : type}
      />
    </MobileSolutionHistoryWrapper>
  );
};

export default MobileSolutionHistory;
